import React from 'react';
import styled from 'styled-components';
import { dateUtils } from '../../../utils/dateUtils';
import { makeTransparentColor } from '../../../assets/styles/transparentColor';
import { theme } from '../../../assets/styles/theme';
import { TextMain } from '../../typography/Texts';

const CreatedText = styled(TextMain)`
  color: ${makeTransparentColor(theme.color.black, 0.5)};
  font-weight: 400;
`;

interface Props {
  created: string;
}

const BidCreatedInfo = ({ created }: Props) => {
  return <CreatedText>{dateUtils.formatDateTime(dateUtils.parseBackendDate(created))}</CreatedText>;
};

export default BidCreatedInfo;
